export const ADMIN_ROUTE_CUSTOMERS = "customers";
export const ADMIN_ROUTE_CUSTOMERS_VIEW = `${ADMIN_ROUTE_CUSTOMERS}/view`;
export const ADMIN_ROUTE_CUSTOMERS_FORM = `${ADMIN_ROUTE_CUSTOMERS}/form`;
